import { all } from 'redux-saga/effects';
import { importJourneySummarySagaHandler } from './ImportJourneySummarySaga';

/**
 * Root Saga function to combine all sagas
 */
export function* rootSaga() {
  yield all([
    ...importJourneySummarySagaHandler
  ]);
}
